/* eslint-disable @typescript-eslint/naming-convention */
import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { StepsManagementService } from '../../shared/services/steps-management.service';
import { ROUTER_PATHS } from '../../app.const';

export const canDeactivateForwardNavigationGuard: CanDeactivateFn<unknown> = (
  _component,
  _nextState,
  currentState,
  currentRoute
) => {
  const currentRouteName = currentRoute?.url;
  const currentStateName = currentState?.url;
  const stepsManagementService = inject(StepsManagementService);
  const tripDetailsCase =
    stepsManagementService.isBrowserNavigation && currentStateName.includes(ROUTER_PATHS.TRIP_DETAILS);
  const secureCheckoutCase =
    stepsManagementService.isBrowserNavigation &&
    currentStateName.includes(ROUTER_PATHS.TRAVELER_DETAILS) &&
    currentRouteName.includes(ROUTER_PATHS.SECURE_CHECKOUT);

  if (currentRouteName.includes(ROUTER_PATHS.UNDER_CONSTRUCTION)) return true;

  return !(tripDetailsCase || secureCheckoutCase);
};
